import { motion } from "framer-motion";
import { container, itemUp } from "../Utils/framerMotionVariants";

const About: React.FC = () => {
  return (
    <section id="about" className="mt-20 scroll-mt-28">
      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        variants={container}
      >
        <motion.h2
          variants={itemUp}
          className="text-2xl font-semibold text-cyan-700"
        >
          About
        </motion.h2>
        <motion.p variants={itemUp} className="mt-4 text-gray-200">
          Results-driven Software Engineer with nearly 4 years of professional
          experience in Java, Python, TypeScript, NodeJS, Angular, React, .NET,
          full-stack, web, and mobile development. Skilled in building scalable
          enterprise solutions, POS systems, and cloud-native applications.
          Recently completed a Master of Computing (Computer Science) at Curtin
          University (CWA 78.36). Authorised to work full-time in Australia.
          Passionate about solving complex problems, delivering high-quality
          software, and contributing to innovative engineering teams
        </motion.p>
      </motion.div>
    </section>
  );
};
export default About;
